import getCountry from "./getCountry";
export default function returnFilter(option) {
  const country = getCountry();
  let forFilter = [];
  switch (option) {
    case "tops":
      if (country === "fr") {
        forFilter = [];
      } else {
        forFilter = ["hem"];
      }
      break;
    case "dresses_jumpsuits":
      if (country === "fr") {
        forFilter = [];
      } else {
        forFilter = ["zip"];
      }
      break;
    case "outerwear":
      if (country === "fr") {
        forFilter = ["zip"];
      } else {
        forFilter = ["hem", "zip"];
      }
      break;

    default:
      forFilter = [];
  }
  return forFilter;
}
